import { useApplication } from 'global/Application/Context';
import PageLoading from 'global/PageLoading';
import React, { useEffect, useState } from 'react';

const ConfigAttributeDiagnosis: React.FC = () => {

    const [documentFile, setDocumentFile] = useState<string | null>(null);

    const application = useApplication();

    useEffect(() => {
        const abortController = new AbortController();

        (async () => {
            const dataSource = application.dataSource;


            const bcbs_config_masterattributes = await dataSource.bcbs_config_masterattributes_getAsync(
                {
                    additionalHeaders: {
                        'x-gl-cache': 'cache-with-revalidate',
                        'x-gl-cache-revalidate-delay': '1000'
                    },
                    controller: abortController
                }
            );

            const bcbs_config_attributes = await dataSource.bcbs_config_attributes_getAsync(
                {
                    additionalHeaders: {
                        'x-gl-cache': 'cache-with-revalidate',
                        'x-gl-cache-revalidate-delay': '1000'
                    },
                    controller: abortController
                }
            );

            const log = JSON.stringify(
                {
                    bcbs_config_masterattributes,
                    bcbs_config_attributes,
                }
            );

            const blob = new Blob([log], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            setDocumentFile(url);

        })();

        return () => {
            // TS complains about abort not accepting a string reason
            (abortController as any).abort('ConfigAttributeDiagnosis component unmounted, aborting fetch');
        }
    }, []);

    if (documentFile)
        return (
            <iframe
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none',
                    // position: 'fixed'
                }}
                src={`./diagnosis/bcbs_config_attribute.html?file=${encodeURIComponent(documentFile)}`}
            />
        );

    return (
        <PageLoading />
    )
};

export default ConfigAttributeDiagnosis;